import axios from "axios";
// const BASE_URL = "https://api-prod.iamsigner.com"  ;
const BASE_URL = "https://api-prod.iamsigner.com";

export default axios.create({
  baseURL: BASE_URL,
});